import { z } from 'zod';
import { BusinessCaseSchema } from '@schuettflix/interfaces';
import { FinanceSettingsSchema } from '@/shared/models/ContextDataModel/interfaces/entities/finance-settings.ts';
import { ProductConfigurationSchema } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';

export const OrderConfigurationSchema = z.object({
    businessCase: BusinessCaseSchema,
    platformOrganizationId: z.number().positive(),
    marketCode: z.string(),
    financeSettings: z.array(FinanceSettingsSchema),
    productConfigurations: z.array(ProductConfigurationSchema),
});

export type OrderConfiguration = z.infer<typeof OrderConfigurationSchema>;
